import { render, staticRenderFns } from "./ElementScaleTableColumn.vue?vue&type=template&id=63dbc109"
import script from "./ElementScaleTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementScaleTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports